import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { ApiManager } from '../../core/api-manager';
import { ResourceManager } from '../../core/resource-manager';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalRcUserCredits, ModalRcUserStatus } from '../components/LTDH_UserRevenueCat';


export default function DataGridLastTdHook({ item, props, entity = null , refreshData = () => {} }) {

    const [showModalUserCredits , setShowModalUserCredits] = useState(false)
    const [showModalUserStatus , setShowModalUserStatus] = useState(false)

    const [BlockQuotationActions , setBlockQuotationActions] = useState(false);
    function handleGenerateQuotationPDF(idQuotation) {
        setBlockQuotationActions(true);
        ApiManager.sendAuthenticatedRequest('/custom/generate_quotation', { idQuotation: idQuotation })
            .then((response) => {
                if(response.success === 1) {
                    toast.success('Preventivo PDF generato con successo. Puoi procedi con l\'invio al cliente');
                } else {
                    toast.error(response.user_message || 'Si è verificato un errore durante la generazione del PDF del preventivo.');
                }
            }).catch((error) => {
                toast.error('Si è verificato un errore durante la generazione del PDF del preventivo.');
            }).finally(() => {
                setBlockQuotationActions(false);
                refreshData();
            });
    };

    function handleSendQuotationToClient(idQuotation) {
        setBlockQuotationActions(true);
        ApiManager.sendAuthenticatedRequest('/custom/send_quotation_to_client', { idQuotation: idQuotation })
            .then((response) => {
                if(response.success === 1) {
                    toast.success('Preventivo inviato al cliente con successo.');
                } else {
                    toast.error(response.user_message || 'Si è verificato un errore durante l\'invio del preventivo al cliente.');
                }
            }).catch((error) => {
                toast.error('Si è verificato un errore durante l\'invio del preventivo al cliente.');
            }).finally(() => {
                setBlockQuotationActions(false);
                refreshData();
            });
    }

    function handleSendQuotationToAdmin(idQuotation) {
        setBlockQuotationActions(true);
        ApiManager.sendAuthenticatedRequest('/custom/send_quotation_to_admin', { idQuotation: idQuotation })
            .then((response) => {
                if(response.success === 1) {
                    toast.success('Preventivo inviato agli amministratori con successo');
                } else {
                    toast.error(response.user_message || 'Si è verificato un errore durante l\'invio del preventivo agli amministratori.');
                }
            }).catch((error) => {
                toast.error('Si è verificato un errore durante l\'invio del preventivo agli amministratori.');
            }).finally(() => {
                setBlockQuotationActions(false);
                refreshData();
            });
    }


    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch(entity) {
                        case 'media': return (
                            <>
                                {item.file && (
                                    <Button variant="secondary" onClick={() => {
                                        const url = ResourceManager.getFileUrl(item.file, 'media');
                                        navigator.clipboard.writeText(url);
                                        toast.success('Link copiato negli appunti');
                                    }}>
                                        <FontAwesomeIcon icon="link" /> Copia link
                                    </Button>
                                )}
                            </>
                        );
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'quotation': return (
                            <>
                                <Button variant="success" className='me-2' disabled={BlockQuotationActions} onClick={() => handleGenerateQuotationPDF(item.id)}>
                                    <FontAwesomeIcon icon="file-pdf" /> Genera
                                    {/* {BlockQuotationActions && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>} */}
                                </Button>
                                <Button variant="primary" className={`me-2 ${ item.file > 0 ? '' : 'hidden'}`} disabled={BlockQuotationActions} onClick={() => handleSendQuotationToClient(item.id)}>
                                    <FontAwesomeIcon icon="share" /> Cliente
                                    {/* {BlockQuotationActions && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>} */}
                                </Button>
                                <Button variant="warning" className={`me-2 ${ item.file > 0 ? '' : 'hidden'} text-black`} disabled={BlockQuotationActions} onClick={() => handleSendQuotationToAdmin(item.id)}>
                                    <FontAwesomeIcon icon="reply" /> Admin
                                    {/* {BlockQuotationActions && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>} */}
                                </Button>
                            </>
                        );
                        case 'user': return (
                            <>
                                <Button variant="success" className='me-2' onClick={() => setShowModalUserStatus(true)}>
                                    <FontAwesomeIcon icon="file" /> Stato abbonamento
                                    {/* {BlockQuotationActions && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>} */}
                                </Button>
                                <Button variant="primary" onClick={() => setShowModalUserCredits(true)}>
                                    <FontAwesomeIcon icon="coins" /> Stato crediti
                                    {/* {BlockQuotationActions && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>} */}
                                </Button>
                                <ModalRcUserCredits
                                    idUser={item.id}
                                    show={showModalUserCredits}
                                    onClose={() => setShowModalUserCredits(false)}
                                />
                                <ModalRcUserStatus
                                    idUser={item.id}
                                    show={showModalUserStatus}
                                    onClose={() => setShowModalUserStatus(false)}
                                />
                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
